function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { tableCellClasses } from "@mui/material/TableCell";
import { tableRowClasses } from "@mui/material/TableRow";
import { getBorderToken, getTableToken } from "../fundations/palette/colorTokens";
import { Corner8 } from "../fundations/shape/corners";
export const Table = {
    MuiTableContainer: {
        defaultProps: {
            component: "div"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    border: `1px solid ${getBorderToken("border300", theme)}`,
                    borderRadius: Corner8
                })
        }
    },
    MuiTableRow: {
        defaultProps: {
            hover: true
        },
        styleOverrides: {
            root: ({ theme })=>({
                    borderBottom: `1px solid ${getBorderToken("border300", theme)}`,
                    [`&:not(.${tableRowClasses.head}):last-child`]: {
                        borderBottom: "none"
                    }
                })
        }
    },
    MuiTableCell: {
        styleOverrides: {
            root: ({ theme })=>_object_spread_props(_object_spread({
                    border: 0
                }, theme.typography.textSm), {
                    [`&.${tableCellClasses.stickyHeader}`]: {
                        backgroundColor: theme.palette.background.paper
                    },
                    [`&.${tableCellClasses.head}`]: _object_spread({
                        fontWeight: 500
                    }, theme.typography.textSm),
                    [`&.${tableCellClasses.sizeMedium}`]: {
                        padding: theme.spacing(2, 3),
                        [`&.${tableCellClasses.paddingCheckbox}`]: {
                            textAlign: "center"
                        },
                        [`&.${tableCellClasses.paddingNone}`]: {
                            padding: theme.spacing(0)
                        }
                    }
                })
        }
    },
    MuiTableHead: {
        styleOverrides: {
            root: ({ theme })=>({
                    [`.${tableCellClasses.root}`]: {
                        background: getTableToken("tableBackground", theme)
                    }
                })
        }
    }
};

//# sourceMappingURL=Table.js.map